import {copyKeyOf, shortDate, STATE_DONE, TASK_JOINED} from './state/learnModel';

/**
 * Los textos que arman la página, el lanzador y la entrada del menú con las mismas claves. Viven
 * acá y no en cada componente porque la celebración y el aviso de un Admin se dibujan en dos lugares
 * (la página y el lanzador) y tienen que decir lo mismo.
 *
 * Todo valor interpolado va con `escapeValue: false`: el nombre de una agencia o de una persona y las
 * fechas («30/09») se mostrarían como entidades HTML (`30&#x2F;09`) — `src/i18n.js` no lo apaga.
 */

const RAW = {interpolation: {escapeValue: false}};

/**
 * `model` es opcional y decide de qué claves salen los textos de la tarea (`copyKeyOf`): la de alertas
 * con el Centro de Alertas es otra tarea con la misma clave del backend. Sin modelo, los de su clave.
 */
export function taskTitle(t, key, agencyName = '', model = null) {
    if (key === TASK_JOINED) return t(`learn_dashbo.tasks.${key}.title`, {agency: agencyName, ...RAW});
    return t(`learn_dashbo.tasks.${copyKeyOf(model, key)}.title`);
}

export function trackTitle(t, key) {
    return t(`learn_dashbo.tracks.${key}.title`);
}

/** «¡Listo! <lo que se destrabó>»: con el título de LOGRO de cada tarea, no el imperativo. */
export function celebrationText(t, keys, model = null) {
    if (!keys || !keys.length) return '';
    const text = keys.map((key) => t(`learn_dashbo.tasks.${copyKeyOf(model, key)}.done_title`)).join(' · ');
    return t('learn_dashbo.celebrate', {text, ...RAW});
}

/** «Ana te recordó: <tarea>». */
export function nudgeText(t, nudge, agencyName = '', model = null) {
    if (!nudge) return '';
    return t('learn_dashbo.nudge', {name: nudge.fromName, task: taskTitle(t, nudge.taskKey, agencyName, model), ...RAW});
}

/**
 * La nota de una tarea hecha: «Hecho el 30/09», o «Lo hizo Ana el 28/09» si es de la agencia y la
 * hizo otra persona. Sin fecha (`joined_agency` no tiene una confiable) sale sólo el estado.
 */
export function doneNote(t, task, language) {
    if (!task || task.state !== STATE_DONE) return '';
    const date = shortDate(task.doneAt, language);
    if (task.doneBy && task.doneBy.name) {
        return date
            ? t('learn_dashbo.task.done_by', {name: task.doneBy.name, date, ...RAW})
            : t('learn_dashbo.task.done_by_nodate', {name: task.doneBy.name, ...RAW});
    }
    // Hecha por otra persona del equipo que no tiene nombre cargado.
    if (task.doneBy) {
        return date
            ? t('learn_dashbo.task.done_by_teammate', {date, ...RAW})
            : t('learn_dashbo.task.done_by_teammate_nodate');
    }
    if (task.key === TASK_JOINED) return '';
    return date ? t('learn_dashbo.task.done_on', {date, ...RAW}) : t('learn_dashbo.task.state.done');
}
